// extracted by mini-css-extract-plugin
module.exports = {"body":"Home_body__3Y4Va"};